/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React, { FunctionComponent } from "react";
import styled from "../../../themes/global";
import { HTMLCustomProps } from "../../../types/css";

export const Etext = styled("p")`
  color: ${(props) => props.theme.color.black};
  margin: 0;
  font-size: 16px;
  font-height: ${(props) => props.theme.font.pLineHight};
  font-family: ${(props) => props.theme.font.family};
  font-weight: 300;
  opacity: 0.75;
  display: flex;
  justify-content: center;
  align-items: center;
  word-break: break-all;
  white-space: pre-wrap;
`;

const Text: FunctionComponent<HTMLCustomProps<HTMLParagraphElement>> = (
  props
) => {
  return <Etext {...props}>{props.children}</Etext>;
};

export default Text;
